export default "__VITE_ASSET__CB6zKiF7__"